import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, message } from "antd";
import { useEffect } from "react";
import { handleArchiveDeal } from "../../../../api/deals";

export default function ArchiveDeal({
  isVisible,
  setVisible,
  deal,
  deal_id,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: handleArchiveDeal,
    onSuccess: () => {
      message.success("Archived Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["deals", deal_id] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const data = { remarks: "Deal Archived" };
    await mutate({ data, deal_id });
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [deal, form]);

  return (
    <Modal
      open={isVisible}
      title="Archive Deal"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="archiveDeal"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Archive
        </Button>,
      ]}
    >
      <Form
        id="archiveDeal"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-col items-center justify-center my-8">
          <div>
            Are you Sure you want to
            <span className="text-automark-dark font-bold mx-1">Archive</span>
            this lead titled
          </div>
          <div className="font-bold text-lg">{deal?.title}?</div>
        </div>
      </Form>
    </Modal>
  );
}
